
import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { DatePipe, formatDate } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-issue-seller-outstandibg-indetail-reports',
  templateUrl: './issue-seller-outstandibg-indetail-reports.component.html',
  styleUrls: ['./issue-seller-outstandibg-indetail-reports.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssueSellerOutstandibgIndetailReportsComponent implements OnInit {


  OutstandingInDetailFormBeans: any = []
  reportType: any;
  startDate: any;
  endDate: any;
  offRepName: any;
  issueDates: any;
  currentDate: string;
  OutStandingIDTotal: number;
  OutStandingIDNetAmtTotal: number;
  OutStandingIDUnPaidTotal: number;
  creditoutstandingindetails: any;
  creditonlyOutStandingIDTotal: number;
  creditonlyOutStandingIDNetAmtTotal: number;
  creditonlyOutStandingIDUnPaidTotal: number;
  onlyOutstandingInDetailFormBeans: any;
  onlyOutStandingIDTotal: number;
  onlyOutStandingIDNetAmtTotal: number;
  onlyOutStandingIDUnPaidTotal: number;
  onlyOutstandingB: any;
  onlytotalNetAmount: number;
  onlytotalAdvtAmount: number;
  onlytotalUnpaidAmount: number;
  onlyOutstandingVB: any;
  creditoutstandongbrief: any;
  creditlastonlytotalAdvtAmount: number;
  creditlastonlytotalNetAmount: number;
  
  creditlastonlytotalUnpaidAmount: number;
  issueDates1: any;
  totalAdvtAmount: number;
  totalNetAmount: number;
  totalUnpaidAmount: number;
  OutstandingB: any;
  Address: any;
  totalAdvt: number;
  totalNet: number;
  totalUnpaid: number;
  constructor(
    private dialogRef: MatDialogRef<IssueSellerOutstandibgIndetailReportsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.reportType = this.data?.reportType || '';
    this.filters(); // ✅ call the method
  }

  filters(): void {
    let repname: any = this.data['repName'];

    if (repname != "") {
      repname = [repname];
    }
    const req: any = {
      "rep_name": repname,
      "startDate": this.data['startDate'],
      "endDate": this.data['endDate'],
      "off_rep_name": this.data['offRepName'],
      "issue_seller_name": this.data['name'],
      "issue_date": this.data['issue_date'],
      "issue_name": this.data['issue_name'],
    
    };
    this.startDate=this.data['startDate']
    this.endDate=this.data['endDate']
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0]; 
    



  this.service.getIssueOutstanding(req).subscribe((data: any) => {
    console.log("outstanding 3", data);
    this.OutstandingInDetailFormBeans = data;

    this.OutStandingIDTotal = 0;
    this.OutStandingIDNetAmtTotal = 0;
    this.OutStandingIDUnPaidTotal = 0;

    for (let item of data) {
      for (let detail of item.rep_data) {
        this.OutStandingIDTotal += parseInt(detail.issue_amt_total) || 0;
        this.OutStandingIDNetAmtTotal += parseInt(detail.net_amt_total) || 0;
        this.OutStandingIDUnPaidTotal += parseInt(detail.unpaid_amt_total) || 0;
      }
    }
  });


this.service.getissueOutstandingB(req).subscribe((data: any) => {
  this.OutstandingB = data || [];

  // Reset grand totals
  this.totalAdvtAmount = 0;
  this.totalNetAmount = 0;
  this.totalUnpaidAmount = 0;

  // Loop through each office representative
  this.OutstandingB.forEach(repData => {
    let advTotal = 0;
    let netTotal = 0;
    let balTotal = 0;

    if (Array.isArray(repData.rep_data)) {
      repData.rep_data.forEach(data1 => {
        advTotal += Number(data1.contract_bkng_advt_amt) || 0;
        netTotal += Number(data1.contract_net_total) || 0;
        balTotal += Number(data1.contract_bal_amt) || 0;
      });
    }

    // Save per-off_rep_name totals
    repData.advTotal = advTotal;
    repData.netTotal = netTotal;
    repData.balTotal = balTotal;

    // Add to grand totals
    this.totalAdvtAmount += advTotal;
    this.totalNetAmount += netTotal;
    this.totalUnpaidAmount += balTotal;
  });
});

  // 2. Credit Outstanding in Details
 this.service.issuecreditoutstaqndingindetails(req).subscribe((data: any) => {
  console.log("credit outstanding", data);
  this.creditoutstandingindetails = data;

  this.creditonlyOutStandingIDTotal = 0;
  this.creditonlyOutStandingIDNetAmtTotal = 0;
  this.creditonlyOutStandingIDUnPaidTotal = 0;

  for (let item of this.creditoutstandingindetails) {
    item.issue_total = 0;
    item.net_total = 0;
    item.bal_total = 0;

    for (let detail of item.rep_data || []) {
      for (let issue of detail.issue_data || []) {
        item.issue_total += parseFloat(issue.issue_amt) || 0;
        item.net_total += parseFloat(issue.net_amt) || 0;
        item.bal_total += parseFloat(issue.unpaid_amt) || 0;
      }
    }

    this.creditonlyOutStandingIDTotal += item.issue_total;
    this.creditonlyOutStandingIDNetAmtTotal += item.net_total;
    this.creditonlyOutStandingIDUnPaidTotal += item.bal_total;
  }
});

  // 3. Only Outstanding in Detail
  this.service.getissueonlyOutstandingindetail(req).subscribe((data: any) => {
    this.onlyOutstandingInDetailFormBeans = data;

    this.onlyOutStandingIDTotal = 0;
    this.onlyOutStandingIDNetAmtTotal = 0;
    this.onlyOutStandingIDUnPaidTotal = 0;

    for (let item of data) {
      for (let detail of item.rep_data) {
        this.onlyOutStandingIDTotal += parseFloat(detail.issue_amt_total) || 0;
        this.onlyOutStandingIDNetAmtTotal += parseFloat(detail.net_amt_total) || 0;
        this.onlyOutStandingIDUnPaidTotal += parseFloat(detail.unpaid_amt_total) || 0;
      }
    }
  });

  // 4. Only  unpaid Outstanding Briefly
this.service.getissueonlyOutstandingB(req).subscribe((data: any) => {
  this.onlyOutstandingB = data || [];

  // Initialize
  this.totalAdvt = 0;
  this.totalNet = 0;
  this.totalUnpaid = 0;

  this.onlyOutstandingB.forEach((repData: any) => {
    if (Array.isArray(repData.rep_data)) {
      repData.rep_data.forEach((detail: any) => {
        this.totalAdvt += Number(detail.issue_total) || 0;
        this.totalNet += Number(detail.net_total) || 0;
        this.totalUnpaid += Number(detail.bal_total) || 0;
      });
    }
  });

  console.log("Grand Totals:", {
    Advt: this.totalAdvt,
    Net: this.totalNet,
    Unpaid: this.totalUnpaid,
  });
});


  // 5. Only Outstanding Very Briefly (Unpaid)
  this.service.getissueonlyOutstandingVB(req).subscribe((data: any) => {
    this.onlyOutstandingVB = data;

    this.onlytotalAdvtAmount = 0;
    this.onlytotalNetAmount = 0;
    this.onlytotalUnpaidAmount = 0;

    for (let item of data) {
      for (let detail of item.rep_data) {
        this.onlytotalAdvtAmount += parseInt(detail.contract_bkng_advt_amt) || 0;
        this.onlytotalNetAmount += parseInt(detail.contract_net_total) || 0;
        this.onlytotalUnpaidAmount += parseInt(detail.contract_bal_amt) || 0;
      }
    }
  });

  // 6. Credit Briefly Outstanding
  this.service.getissuecreditbrieflyoutstanding(req).subscribe((data: any) => {
    this.creditoutstandongbrief = data;

    this.creditlastonlytotalAdvtAmount = 0;
    this.creditlastonlytotalNetAmount = 0;
    this.creditlastonlytotalUnpaidAmount = 0;

    for (let item of data) {
      for (let detail of item.rep_data) {
        this.creditlastonlytotalAdvtAmount += parseInt(detail.contract_bkng_advt_amt) || 0;
        this.creditlastonlytotalNetAmount += parseInt(detail.contract_net_total) || 0;
        this.creditlastonlytotalUnpaidAmount += parseInt(detail.contract_bal_amt) || 0;
      }
    }
  });

    this.service.getAllissuesellerAdd(req).subscribe(
      (data1: any) => {
        this.Address = data1;
        console.log("Final Address array:", this.Address);
        this.cdr.markForCheck(); // Trigger change detection to update the view
      },
      (error) => {
        console.error("Error fetching addresses:", error);
      }
    );
  }


  
  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');


    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }
  

  }